/*
 * Copyright (c) 2020-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { Check } from 'lucide-react';

// Four, not five: at common laptop widths a fifth pill wrapped onto its own
// line and left the row looking broken. Wording matches what a learner actually
// gets on the dashboard.
const BENEFITS = [
  'Resume where you left off',
  'Certificates & badges',
  'Deadline reminders',
  'Team progress analytics',
];

/**
 * Translucent benefit pills shown in the brand panel hero. Each pill pairs a
 * tinted green circle-check with a short label. Decorative content — the check
 * marks are aria-hidden and the list carries its own label.
 */
export default function BenefitPills() {
  return (
    <ul aria-label="Platform benefits" className="mt-8 flex flex-wrap gap-2.5">
      {BENEFITS.map((benefit) => (
        <li
          key={benefit}
          className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.06] px-3 py-1.5 text-[13px] font-semibold text-white/90"
        >
          <span className="grid h-4 w-4 flex-none place-items-center rounded-full bg-emerald-400/15 text-emerald-300">
            <Check className="h-2.5 w-2.5" strokeWidth={3} aria-hidden="true" />
          </span>
          {benefit}
        </li>
      ))}
    </ul>
  );
}
